<template>
  <v-dialog v-model="showReward" max-width="600px">
    <v-card>
      <v-card-title style="justify-content: end; padding: 0" class="headline d-flex justify-space-between lighten-1 white--text">
        <v-btn icon @click="closeDialog" style="max-width: 20%" class="white--text">
           close
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div style="display:flex; margin-top: 10px;">
          <div v-if="bannerImageUrl" class="banner-section">
            <v-img :src="bannerImageUrl" class="banner-image" />
          </div>
          <div class="refer">
            <p style="font-weight: bold; font-size: 28px; line-height: 1.2">
              {{ dialogTitle }}
            </p>
            <p style="margin-top: 10px; font-weight: bold; font-size: 16px; line-height: 1.2" class="subtitle-1">
              {{ dialogInstructions }}
            </p>
          </div>
        </div>

        <div class="d-flex justify-space-between align-center">
          <div>
            <p style="text-align: left; font-size: 16px; margin-top: 10px"><strong>Share your referral link with friends</strong></p>
            <div style="display:flex; align-items: baseline;" class="oblong-container">
                <v-text-field
                    v-model="referralLink"
                    readonly
                    append-outer-icon="mdi-content-copy"
                    outlined
                    hide-details
                    class="copy-link-input"
                >
                </v-text-field>

                <v-btn color="secondary" @click="copyLink" class="copy-btn">
                    Copy Link
                </v-btn>
            </div>
            <socials v-if="referralLink && referralLink.length" :referralLink="referralLink"/>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from 'vuex'
import Socials from '../Socials.vue';
import { matchTranslation } from '@/services/util.service';

export default {
  components: { Socials },
  props: {
    referral: {
      type: Object,
      required: true
    },
    referralLink: {
      type: String,
      default: ''
    },
    referralSettings: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showReward: false
    };
  },
  computed: {
    dialogTitle() {
      const t = this.referralSettings && this.referralSettings.title;
      if (t && t.translations) return matchTranslation(t.translations) || this.referral.rewardName || '';
      return this.referral.rewardName || '';
    },
    dialogInstructions() {
      const settings = this.referralSettings || {};
      const copySource = settings.instructions || settings.description;
      if (copySource && copySource.translations) {
        const translated = matchTranslation(copySource.translations);
        if (translated) return translated;
      }
      return this.referral.referralNameString || '';
    },
    bannerImageUrl() {
      const url = this.referralSettings && this.referralSettings.referralBannerImageUrl;
      if (!url) return null;
      return url.startsWith('http') ? url : `${process.env.VUE_APP_API_IMAGE}${url}`;
    },
    ...mapGetters([
      'isLoggedIn',
      'getStore',
      'getCustomer'
    ])
  },
  mounted() {
    this.$root.$refs.referral = this;
  },
  methods: {
    openDialog() {
      if (this.isLoggedIn) {
        this.SET_OPEN_REFERRAL(true)
        this.showReward = true;
      } else {
        this.SET_OPEN_REFERRAL(false)
        this.showSnack({
          text: 'Please login to get your referral link',
          color: 'secondary'
        })
        this.setLoginDialog(true)
      }
    },
    closeDialog() {
      this.showReward = false;
    },
    copyLink() {
      navigator.clipboard.writeText(this.referralLink);
      this.showSnack({
        text: 'Link copied!',
        color: 'success'
      })
    },
    share(platform) {
      if (platform === 'facebook') {
        window.open(this.reward.fb, '_blank');
      } else if (platform === 'wechat') {
        window.open(this.reward.wechat, '_blank');
      } else if (platform === 'email') {
        window.location.href = `mailto:?body=${this.referralLink}`;
      } else if (platform === 'twitter') {
        window.open(`https://twitter.com/intent/tweet?url=${this.referralLink}`, '_blank');
      }
    },
      ...mapMutations([ 'setLoginDialog', 'SET_OPEN_REFERRAL' ]),
      ...mapActions([ 'showSnack' ])
  }
};
</script>

<style scoped>
.but {
  border-radius: 25px;
  width: 20%;
  height: 45px;
}
.oblong-container {
  display: flex;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
  border: 2px solid var(--v-secondary-base);
  border-radius: 30px;
  background-color: white;
}
.headline {
  background: var(--v-secondary-base);
}
.qr-code {
  max-width: 120px;
  margin-left: 10px;
}

.social-buttons {
  display: flex;
  gap: 10px;
  margin-top: 15px;
  justify-content: center;
  padding-bottom: 15px;
}

.qr-section {
  text-align: center;
  width: 40%;
  display:flex;
  flex-direction: column;
  justify-content: center;
}
.refer{
  width: 100%;
  text-align: left
}
.banner-section {
  width: 40%;
  flex-shrink: 0;
  margin-right: 16px;
}
.banner-image {
  width: 100%;
  border-radius: 8px;
}
.copy-link-input{
  width: 70%;
}
.copy-btn {
  width: 30%;
}
</style>
